import React from 'react';
import "./HeroContact.css";

const HeroContact = () => {
  return (
    <div className='hero_Contact_div'>
      <h1 className='title_1'>Contact Us</h1>
    </div>
  );
};

export default HeroContact;